import { I18n } from 'react-redux-i18n';
import CarouselItem from '../CarouselItem';
import Carousel from 'components/Carousel';
import Kpi from 'components/Kpi';

import { useArticleFeed, useArticleHeader } from 'apiTyped/hooks/articles';

const isMobile = window.innerWidth <= 1200;

const MediaHeader = () => {
  const { articleFeed } = useArticleFeed();
  const { articleHeader } = useArticleHeader();

  const articles = articleFeed?.surveys || [];
  const articleNumber = articleHeader?.nb_articles;

  return (
    <div className="headerContainer">
      <Kpi
        title={I18n.t('media.kpiTitle')}
        subTitle={I18n.t('media.kpiSubTitle') as unknown as undefined}
        value={articleNumber}
        tooltip={
          `${I18n.t(
            'media.kpiTooltip'
          )}  ${articleNumber}` as unknown as undefined
        }
        valueText={null}
        dateText={null}
        date={null}
        handleNext={null}
      />
      {!isMobile && articles.length > 0 && (
        <Carousel
          length={3}
          noMargeLeft
          ItemComponent={CarouselItem}
          data={articles}
        />
      )}
    </div>
  );
};

export default MediaHeader;
